import React from "react";

export const FolderFileFillIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 13C4 11.1144 4 10.1716 4.58579 9.58579C5.17157 9 6.11438 9 8 9H8.34315C9.16065 9 9.5694 9 9.93694 9.15224C10.3045 9.30448 10.5935 9.59351 11.1716 10.1716L11.8284 10.8284C12.4065 11.4065 12.6955 11.6955 13.0631 11.8478C13.4306 12 13.8394 12 14.6569 12H16C17.8856 12 18.8284 12 19.4142 12.5858C20 13.1716 20 14.1144 20 16V16C20 17.8856 20 18.8284 19.4142 19.4142C18.8284 20 17.8856 20 16 20H8C6.11438 20 5.17157 20 4.58579 19.4142C4 18.8284 4 17.8856 4 16V13Z"
                stroke="#CCD2E3"
                strokeWidth="2"
            />
            <path
                d="M18 12V8C18 6.11438 18 5.17157 17.4142 4.58579C16.8284 4 15.8856 4 14 4H10C8.11438 4 7.17157 4 6.58579 4.58579C6 5.17157 6 6.11438 6 8V9"
                stroke="#CCD2E3"
                strokeWidth="2"
            />
        </svg>
    );
};
